const WALLET_OPTIONS = {
  apple_pay: 'applePay',
  google_pay: 'googlePay',
  link: 'link',
}

export function hiddenWallets(excludedWallets = []) {
  return Object.fromEntries(
    excludedWallets
      .filter((type) => WALLET_OPTIONS[type])
      .map((type) => [WALLET_OPTIONS[type], 'never'])
  )
}
